import { ProgressSpinner } from "primereact/progressspinner";
import useLoaderStore from "../../../stores/useLoaderStore";

export default function Loader() {
	const isLoading = useLoaderStore((s: any) => s.isLoading);

	if (!isLoading) return null;

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center"
			style={{
				background: "rgba(0,0,0,0.4)",
				backdropFilter: "blur(1px)",
			}}
		>
			<ProgressSpinner
				style={{ width: "60px", height: "60px", zIndex: "9999" }}
				strokeWidth="6"
				fill="transparent"
				animationDuration=".6s"
			/>
		</div>
	);
}
